import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Incoming: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmail2Incoming"><Path d="M12 19.5H2.5V4.5H21.5L21.5 7.25L12 12.0714L2.73768 7.37063" stroke="currentColor"/><Path d="M19 13L15.5 16.5L19 20" stroke="currentColor"/><Path d="M23 16.5H16" stroke="currentColor"/></CentralIconBase>;
});

export default IconEmail2Incoming;
